var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 .52C8.36.52.52 8.36.52 18S8.36 35.48 18 35.48 35.48 27.64 35.48 18 27.64.52 18 .52m9.657 18.017-6.08 6.08a.76.76 0 0 1-.538.223.76.76 0 0 1-.537-1.297l4.783-4.783H8.88a.76.76 0 0 1-.76-.76c0-.419.34-.76.76-.76h16.405l-4.783-4.783a.76.76 0 1 1 1.075-1.074l6.08 6.08a.76.76 0 0 1 0 1.075"
  })));
};
export default SvgArrow;